import { useInstallPrompt } from "@/hooks/useInstallPrompt";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

export const InstallBanner = () => {
  const { 
    showInstallBanner, 
    triggerInstallPrompt, 
    dismissInstallBanner,
    isInstalled 
  } = useInstallPrompt();

  // Don't show if already installed or banner not ready
  if (isInstalled || !showInstallBanner) return null;

  const handleInstall = async () => {
    await triggerInstallPrompt();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary text-primary-foreground px-4 py-3 shadow-lg animate-in slide-in-from-bottom-5">
      <div className="flex items-center justify-between max-w-screen-lg mx-auto gap-4">
        <div className="flex items-center gap-3">
          <Download className="w-5 h-5 shrink-0" />
          <div className="flex flex-col">
            <span className="text-sm font-medium">Install Serento</span>
            <span className="text-xs opacity-90 hidden sm:block">
              Add to home screen for quick access & offline support
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="secondary"
            className="text-primary"
            onClick={handleInstall}
          >
            Install
          </Button>
          <Button
            size="icon"
            variant="ghost"
            className="h-8 w-8 text-primary-foreground hover:bg-primary-foreground/20"
            onClick={dismissInstallBanner}
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
